@if (form) {
  <form class="action-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
    <span class="title">{{ 'CONSUMPTION.METER.ADD' | translate }}</span>
    <section class="astral-section-surface astral-section-surface--compact">
      <astral-layout-group [columns]="1" [tabletColumns]="1" [mobileColumns]="1">
        @if (meterTypeSelection) {
          <astral-select [control]="form.controls['meterType']" [itemsSource]="meterTypeSelection"></astral-select>
        }
        <astral-input [control]="form.controls['name']"></astral-input>
        <astral-select [control]="form.controls['imdMeterModelId']" [itemsSource]="dataContext.modelSelection"></astral-select>
      </astral-layout-group>
    </section>
    <div class="astral-form-actions">
      <astral-button variant="primary" type="submit" [label]="'OK'"></astral-button>
      <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
    </div>
  </form>
}
